import { MIN_DOMAIN_LENGTH } from './ExternalDomainInputForm.constants';
export function isValidExternalDomain(domain) {
  return domain && domain.length >= MIN_DOMAIN_LENGTH;
}